import React from 'react'
import kebabcase from 'lodash.kebabcase'

import StandingOrderCard, { EmptyStandingOrderCard } from './StandingOrderCard'
import ConsentListSectionHeader from './ConsentListSectionHeader'

import style from './StandingOrders.module.css'

export default function StandingOrders({ standingOrders }) {
  return (
    <section className="js-standing-orders">
      <StandingOrdersSection
        label="Granted"
        description="Permission given to service providers to create standing order mandates on your account. Please note: these mandates will always be listed even if the standing order instruction is cancelled at a later date."
        standingOrders={standingOrders.get('granted')}
        pointedBorder
      />

      <StandingOrdersSection
        label="Failed"
        description=""
        standingOrders={standingOrders.get('failed')}
      />
    </section>
  )
}

function StandingOrdersSection({
  label,
  description,
  standingOrders,
  pointedBorder,
}) {
  return (
    <section
      className={`${style.section} js-standing-orders-${kebabcase(label)}`}
    >
      <ConsentListSectionHeader
        count={standingOrders.size}
        label={label}
        description={description}
        consentType="standingOrder"
        indented
        pointedBorder={pointedBorder}
      />
      {standingOrders.size > 0 ? (
        standingOrders
          .map((standingOrder, index) => (
            <StandingOrderCard
              key={standingOrder.get('id')}
              standingOrder={standingOrder}
              className={`js-standing-order-${index}`}
            />
          ))
          .toArray()
      ) : (
        <EmptyStandingOrderCard />
      )}
    </section>
  )
}
